export default __webpack_public_path__ + "static/media/1-kat_fall_formal_2007.66616c7d.jpg";